<template lang="pug">
  include ./../../../mixins
  +b.video.youtube-frame
    +b.playpause(
      @click="playVideo"
      v-if="!isPlaing"
      :data-string="titleString"
    )
    slot(
      name="preview"
      v-if="!isPlaing"
    )
    +e.VIDEO.video.youtube-frame(
      v-if="mp4Video"
      loop="false",
      autoplay,
      controls,
      ref="video"
    )
      source(type="video/mp4", :src="urlVideo")
    +e.IFRAME.iframe.youtube-frame(
      :src="videoEmbed(videoUrl)"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
      v-if="!mp4Video && isPlaing"
    )
</template>

<script>
export default {
  props: {
    play: {},
    url: String,
    urlVideo: String,
    titleString: String,
  },
  data() {
    return {
      isPlaing: false,
      mp4Video: false,
      videoUrl: '',
    }
  },
  watch: {
    play() {
      this.stopVideo()
    },
  },
  methods: {
    stopVideo() {
      this.isPlaing = false
    },
    playVideo() {
      this.isPlaing = true
      if (this.urlVideo) {
        this.mp4Video = true
      } else {
        this.mp4Video = false
        this.videoUrl = `${this.url}?&mute=1&autoplay=1`
      }
    },
    getVideoId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      const match = url.match(regExp)
      const eleven = 11
      // eslint-disable-next-line eqeqeq
      if (match && match[2].length == eleven) {
        return match[2]
      }
      return 'error'
    },
    videoEmbed(el) {
      const item = `https://www.youtube.com/embed/${this.getVideoId(el)}?rel=0&autoplay=1`
      return item
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/UiPreview.vue